export const getTransactionIdSelector = (state) => state?.home?.transactionId
export const getIsCompletedSelector = (state) => state?.home?.isCompleted
export const getIsOfflineSelector = (state) => state?.home?.isOffline
export const getIsAeonSelector = (state) => state?.home?.isAeon